export const state = () => ({
  count: 0,
  airports: [],
  response: {}
})

export const getters = {
  getAirports: state => state.airports,
  getCount: state => state.count,
  getResponse: state => state.response
}

export const mutations = {
  setAirports (state, value) {
    state.airports = value
  },

  setCount (state, value) {
    state.count = value
  },

  setResponse (state, value) {
    state.response = value
  }
}

export const actions = {
  async fetchAirports ({ commit, state }, { params = {}, loadNext = false }) {
    let url = '/airports/'
    if (loadNext && state.response?.next) {
      url = state.response.next
    }

    await this.$axios.$get(url, { params })
      .then((response) => {
        if (loadNext) {
          commit('setAirports', [...state.airports, ...response.results])
        } else {
          commit('setAirports', response.results)
        }

        commit('setCount', response.count || 0)
        commit('setResponse', response || {})
      })
  }
}
